<template>
  <div>
    {{ params.value[0].name }}
  </div>
</template>

<script>
export default {
  name: 'CellRendererCompany',
  computed: {
    companyName(companyObj) {
      console.log(companyObj)
      // const company = JSON.stringify(companyObj)
      return companyObj.name
    }
  }
}
</script>

<style scoped>

</style>
